/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type maintenance_viewer = {
    readonly component: string | null;
    readonly downForMaintenance: boolean | null;
    readonly " $refType": "maintenance_viewer";
};
export type maintenance_viewer$data = maintenance_viewer;
export type maintenance_viewer$key = {
    readonly " $data"?: maintenance_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"maintenance_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "maintenance_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "maintenance"
        }
      ],
      "kind": "ScalarField",
      "name": "component",
      "storageKey": "component(name:\"maintenance\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downForMaintenance",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = 'e1930cc4ebc9273d3744932aa182fff4';
export default node;
